/**
 * Application Constants
 * Centralized configuration for the Fintrack application
 */

/**
 * Get APP_ID based on current year
 * This ensures data is properly scoped and can be migrated year-over-year
 * @returns {string} APP_ID for current year
 */
export const getAppId = () => {
  // You can customize this logic based on your needs
  // For now, we use current year to maintain year-based data separation
  const currentYear = new Date().getFullYear();
  return `fintrack-${currentYear}-prod`;
};

/**
 * Default APP_ID (FIXED to preserve existing data)
 * Changed from dynamic to fixed to maintain data consistency
 */
export const APP_ID = 'fintrack-2025-prod';

/**
 * Legacy APP_IDs for data migration purposes
 */
export const LEGACY_APP_IDS = [
  'fintrack-2025-prod',
  'fintrack-2024-prod'
];

/**
 * Supported currencies
 */
export const CURRENCIES = {
  VND: { code: 'VND', symbol: 'đ', locale: 'vi-VN', name: 'Vietnamese Dong' },
  USD: { code: 'USD', symbol: '$', locale: 'en-US', name: 'US Dollar' },
  EUR: { code: 'EUR', symbol: '€', locale: 'de-DE', name: 'Euro' },
  GBP: { code: 'GBP', symbol: '£', locale: 'en-GB', name: 'British Pound' },
  JPY: { code: 'JPY', symbol: '¥', locale: 'ja-JP', name: 'Japanese Yen' },
  CNY: { code: 'CNY', symbol: '¥', locale: 'zh-CN', name: 'Chinese Yuan' }
};

/**
 * Supported languages
 */
export const LANGUAGES = {
  VI: { code: 'vi', name: 'Tiếng Việt' },
  EN: { code: 'en', name: 'English' }
};

/**
 * Default values
 */
export const DEFAULTS = {
  CURRENCY: 'VND',
  LANGUAGE: 'vi',
  YEAR: new Date().getFullYear()
};

/**
 * Year validation rules
 */
export const YEAR_VALIDATION = {
  MIN_YEAR: 2024,
  MAX_YEAR_OFFSET: 5, // Allow creating up to 5 years in the future
  DEFAULT_YEARS: [2025, 2026]
};

/**
 * Validate year
 * @param {number} year - Year to validate
 * @returns {boolean} - Is valid
 */
export const isValidYear = (year) => {
  const currentYear = new Date().getFullYear();
  return year >= YEAR_VALIDATION.MIN_YEAR && 
         year <= currentYear + YEAR_VALIDATION.MAX_YEAR_OFFSET;
};
